module.exports = __webpack_public_path__ + "assets/img/logo_bottom.940b0d88.png";